import { render, staticRenderFns } from "./BcModalPrint.vue?vue&type=template&id=66014b9b"
import script from "./BcModalPrint.vue?vue&type=script&lang=js"
export * from "./BcModalPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports